export default "__VITE_ASSET__BvT40d_T__"